import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { actions, selectors } from 'modules/debts';
import { actions as modalActions } from 'modules/modal';
import { actions as userActions, selectors as userSelectors } from 'modules/user';

import ActionBar from './ActionBar';

class ActionBarContainer extends PureComponent {
  reorder = () => {
    const { debts, onReorder, showModal } = this.props;
    showModal('debtOrder', {
      details: { debts },
      onClose: debts => onReorder(debts),
    });
  };

  render() {
    return <ActionBar {...this.props} onOrder={this.reorder} />;
  }
}

const mapStateToProps = state => ({
  debts: selectors.debts(state),
  settings: userSelectors.settings(state),
  currentProgress: selectors.currentProgress(state),
  startingBalance: selectors.startingBalance(state),
  totalBalance: selectors.totalBalance(state),
  totalPaid: selectors.totalPaid(state),
});

export default connect(mapStateToProps, {
  onReorder: actions.reorderDebts,
  onSettingsChange: userActions.updateSettings,
  showModal: modalActions.showModal,
})(ActionBarContainer);



// WEBPACK FOOTER //
// ./src/components/ActionBar/ActionBar.container.js